(function () {
  var waves = [];
  var started = false;
  var prefersReduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(canvas) {
    if (canvas.__sig) return null;
    canvas.__sig = true;

    var ctx = canvas.getContext('2d');
    var cfg = {
      amp: parseFloat(canvas.dataset.amp) || 24,
      speed: parseFloat(canvas.dataset.speed) || 18,
      glow: parseFloat(canvas.dataset.glow) || 20,
      detail: Math.max(1, parseInt(canvas.dataset.detail, 10) || 4),
      cursor: canvas.dataset.cursor !== 'off',
    };
    var w = {
      canvas: canvas,
      ctx: ctx,
      cfg: cfg,
      W: 1,
      H: 1,
      dpr: Math.max(1, Math.min(2, window.devicePixelRatio || 1)),
      color: '#ffffff',
      mx: -99999,
      my: 0,
      hasMouse: false,
      visible: true,
    };

    function resize() {
      var rect = canvas.getBoundingClientRect();
      w.W = Math.max(1, Math.round(rect.width));
      w.H = Math.max(1, Math.round(rect.height));
      canvas.width = Math.round(w.W * w.dpr);
      canvas.height = Math.round(w.H * w.dpr);
      ctx.setTransform(w.dpr, 0, 0, w.dpr, 0, 0);
      var c = getComputedStyle(canvas).color;
      if (c) w.color = c;
    }
    resize();

    if (window.ResizeObserver) {
      new ResizeObserver(resize).observe(canvas);
    } else {
      window.addEventListener('resize', resize);
    }

    if (cfg.cursor && !prefersReduced) {
      canvas.addEventListener('mousemove', function (e) {
        var r = canvas.getBoundingClientRect();
        w.mx = e.clientX - r.left;
        w.my = e.clientY - r.top;
        w.hasMouse = true;
      });
      canvas.addEventListener('mouseleave', function () {
        w.hasMouse = false;
      });
    }

    if (window.IntersectionObserver) {
      new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) w.visible = entries[i].isIntersecting;
        },
        { threshold: 0 }
      ).observe(canvas);
    }

    return w;
  }

  function waveY(w, x, t) {
    var cfg = w.cfg,
      H = w.H,
      W = w.W,
      cy = H / 2;
    var ampPx = cfg.amp * (H / 180);
    var e = Math.min(x, W - x) / (W * 0.12);
    if (e > 1) e = 1;
    if (e < 0) e = 0;
    var env = e * e * (3 - 2 * e);
    var y = 0;
    for (var k = 1; k <= cfg.detail; k++) {
      y +=
        (ampPx / k) *
        Math.sin(
          (k * 1.7 * Math.PI * x) / W + t * (0.5 + (cfg.speed / 100) * 2.4) * (0.45 + k * 0.4) + k * 1.3
        );
    }
    y *= 0.72 + 0.28 * Math.sin(t * 0.7);
    if (cfg.cursor && w.hasMouse) {
      var d = x - w.mx,
        sig = W * 0.06;
      y += (cy - w.my) * Math.exp(-(d * d) / (2 * sig * sig));
    }
    return cy - y * env;
  }

  function draw(w, t) {
    var ctx = w.ctx,
      W = w.W,
      H = w.H;
    ctx.clearRect(0, 0, W, H);

    ctx.beginPath();
    for (var x = 0; x <= W; x += 3) {
      var y = waveY(w, x, t);
      if (x === 0) ctx.moveTo(x, y);
      else ctx.lineTo(x, y);
    }
    var glowPx = w.cfg.glow * Math.min(1, H / 120);
    ctx.shadowBlur = glowPx;
    ctx.shadowColor = w.color;
    ctx.strokeStyle = w.color;
    ctx.lineWidth = Math.max(1.25, H * 0.016);
    ctx.lineJoin = 'round';
    ctx.lineCap = 'round';
    ctx.stroke();

    var px = (t * (50 + w.cfg.speed * 2.5)) % W;
    var py = waveY(w, px, t);
    ctx.beginPath();
    ctx.arc(px, py, Math.max(2, H * 0.024), 0, Math.PI * 2);
    ctx.shadowBlur = glowPx + 8;
    ctx.fillStyle = w.color;
    ctx.fill();
    ctx.shadowBlur = 0;
  }

  function loop(ts) {
    loop._last = loop._last || ts;
    var dt = Math.min(0.05, (ts - loop._last) / 1000);
    loop._last = ts;
    loop._t = (loop._t || 0) + dt;
    for (var i = 0; i < waves.length; i++) {
      if (waves[i].visible) draw(waves[i], loop._t);
    }
    requestAnimationFrame(loop);
  }

  function init() {
    var els = document.querySelectorAll('canvas[data-signal-wave]');
    for (var i = 0; i < els.length; i++) {
      var w = setup(els[i]);
      if (w) waves.push(w);
    }
    if (!waves.length) return;
    if (prefersReduced) {
      for (var j = 0; j < waves.length; j++) draw(waves[j], 6.0);
      return;
    }
    if (!started) {
      started = true;
      requestAnimationFrame(loop);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
